import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleSignUp = async (payload) => {
  try {
    const { data } = await instance.post('/users', payload);

    return data;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/signUp/index.js